import { FC } from 'react';
import { TableProps } from 'antd';
import { Fx, Layout, Table, Button } from 'Components';
import { LayoutHolder } from 'Pages/Dashboard/components';
import { OverviewGroupSummary } from 'Services/Api/Dashboard/Types';
import { getGroupSummaryColumns } from './columns';

interface GroupSummaryTableProps {
	data?: OverviewGroupSummary[];
	loading?: boolean;
	title?: string;
	onChange?: TableProps<OverviewGroupSummary>['onChange'];
	onDownload?: () => void;
}

const GroupSummaryTable: FC<GroupSummaryTableProps> = ({
	data = [],
	loading = false,
	title = 'Group Summary',
	onChange,
	onDownload
}) => {
	return (
		<LayoutHolder>
			<Layout>
				<Layout.Heading>
					<Fx align="middle" justify="space-between">
						<h3>{title}</h3>
						<Button type="default" onClick={onDownload}>
							Download Report
						</Button>
					</Fx>
				</Layout.Heading>
				<Table<OverviewGroupSummary>
					rowKey="groupName"
					dataSource={data}
					columns={getGroupSummaryColumns()}
					pagination={false}
					loading={loading}
					onChange={onChange}
				/>
			</Layout>
		</LayoutHolder>
	);
};

export default GroupSummaryTable;
